import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CircularLoader from "@/components/atoms/CircularLoader";
import ErrorMessage from "@/components/atoms/ErrorMessage";
import Footer from "@/components/molecules/Footer";
import Header from "@/components/molecules/Header";
import UserDataForm from "@/components/organisms/UserDataForm";
import i18n from "@/translate/i18n";
import useRedirect from "@/hooks/useRedirect";
import { getTransactionData } from "@/services/api";
import { useTransactionData } from "@/context/transactionContext";
import { LayoutWrapper1xbet } from "@/components/molecules/Wrappers/LayoutWrapper1xbet";

function Checkout1xbet() {
  const history = useHistory();
  const { id, token } = useParams();
  const [error, setError] = useState("");
  const [isFetching, setIsFetching] = useState(true);
  const { transactionData, setTransactionData } = useTransactionData();
  const { checkDataAndRedirect } = useRedirect();
  const [retryableError, setRetryableError] = useState(null);

  useEffect(() => {
    const getTransaction = async () => {
      try {
        setRetryableError(null);
        setError("");
        setIsFetching(true);
        const res = await getTransactionData(id, token);
        setTransactionData(res.data);
      } catch (err) {
        const message = err?.response?.data?.message;
        setError(i18n.t([`error.${message}`, "error.unspecific"]));
      } finally {
        setIsFetching(false);
      }
    };

    if (!Object.keys(transactionData)?.length) {
      getTransaction();
    } else {
      setIsFetching(false);
    }
  }, [history, id, setTransactionData, token, transactionData]);

  useEffect(() => {
    if (transactionData && Object.keys(transactionData).length > 0 && !error) {
      checkDataAndRedirect();
    }
  }, [transactionData, checkDataAndRedirect, error]);

  if (isFetching) {
    return (
      <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
        <CircularLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
        <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
          <ErrorMessage
            handleClick={() => window.location.reload()}
            isExpired={error === "Token no válido"}
            errorType={error}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header
          title={i18n.t("header.previous")}
          handleClick={
            transactionData?.type === "withdrawal"
              ? () =>
                  history.push(
                    `/payment-data/${id}/${token}${history.location.search}`,
                  )
              : undefined
          }
        />
        <LayoutWrapper1xbet>
          <UserDataForm
            data={transactionData}
            setData={setTransactionData}
            setError={setError}
            setIsFetching={setIsFetching}
            retryableError={retryableError}
            setRetryableError={setRetryableError}
          />
        </LayoutWrapper1xbet>
        <Footer />
      </div>
    </div>
  );
}

export default Checkout1xbet;
